import { Component, inject, OnInit } from '@angular/core';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';

import { HeaderComponent } from './core/components/header/header.component';
import { BroadcastMessageComponent } from './core/components/broadcast-message/broadcast-message.component';
import { RewardBannerComponent } from './core/components/reward-banner/reward-banner.component';
import { ErrorPopupComponent } from './core/components/error-popup/error-popup.component';
import { FooterComponent } from './core/components/footer/footer.component';
import { ScrollService } from './core/services/scroll.service';
import { filter, Subject, takeUntil } from 'rxjs';

/**
 * App Component
 * The root component of the scottishpower business energy quote application
 * Provides the main layout structure with header, content area, and footer
 */
@Component({
  selector: 'app-root',
  imports: [RouterOutlet, HeaderComponent, BroadcastMessageComponent, RewardBannerComponent, ErrorPopupComponent, FooterComponent],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent implements OnInit {
  private destroy$ = new Subject<void>();
  isQuotePage: boolean = false;
  constructor(
    private router: Router
  ) { }

  ngOnInit(): void {
    // Listen to route changes
    this.router.events.pipe(
      filter((event): event is NavigationEnd => event instanceof NavigationEnd),
      takeUntil(this.destroy$)
    ).subscribe((event: NavigationEnd) => {
      this.isQuotePage = event.urlAfterRedirects.includes('/quotes');
    });
  }
}
